import { AxiosResponse } from 'axios';
import { DEVICE_INFO_API_URL } from '../../../config';
import deviceInfoAxios from '../../../utils/axios/deviceInfo.axios';

/** GET /journey-reports/trip/:tripId/hod/:type */
const fetchHodReport = (
    tripId: string,
    type: 'cabin' | 'bar' | 'restaurant',
): Promise<AxiosResponse<any>> => {
    return deviceInfoAxios.get(`${DEVICE_INFO_API_URL}/journey-reports/trip/${tripId}/hod/${type}`);
};

/** PUT /journey-reports/trip/:tripId/hod/:type */
const saveHodReport = (
    tripId: string,
    type: 'cabin' | 'bar' | 'restaurant',
    data: { sections: Array<{ cabinId: string; editedSummary: string }> },
): Promise<AxiosResponse<any>> => {
    return deviceInfoAxios.put(`${DEVICE_INFO_API_URL}/journey-reports/trip/${tripId}/hod/${type}`, data);
};

/** GET /journey-reports/trip/:tripId/tm-report */
const fetchTmReport = (tripId: string): Promise<AxiosResponse<any>> => {
    return deviceInfoAxios.get(`${DEVICE_INFO_API_URL}/journey-reports/trip/${tripId}/tm-report`);
};

/** PUT /journey-reports/trip/:tripId/tm-report */
const saveTmReport = (
    tripId: string,
    data: {
        sections?: Array<{ cabinId: string; editedSummary: string }>;
        editedDraft?: string;
    },
): Promise<AxiosResponse<any>> => {
    return deviceInfoAxios.put(`${DEVICE_INFO_API_URL}/journey-reports/trip/${tripId}/tm-report`, data);
};

/** GET /journey-reports/trip/:tripId/export/docx */
const exportDocx = (tripId: string): Promise<AxiosResponse<any>> => {
    return deviceInfoAxios.get(`${DEVICE_INFO_API_URL}/journey-reports/trip/${tripId}/export/docx`);
};

/** GET /journey-reports/trip/:tripId/export/pdf */
const exportPdf = (tripId: string): Promise<AxiosResponse<any>> => {
    return deviceInfoAxios.get(`${DEVICE_INFO_API_URL}/journey-reports/trip/${tripId}/export/pdf`);
};

/** GET /journey-reports/historical */
const fetchHistorical = (
    params: { page?: number; size?: number },
): Promise<AxiosResponse<any>> => {
    const query = `page=${params.page || 1}&size=${params.size || 20}`;
    return deviceInfoAxios.get(`${DEVICE_INFO_API_URL}/journey-reports/historical?${query}`);
};

/** GET /journey-reports/historical/:tripId */
const fetchHistoricalDetail = (tripId: string): Promise<AxiosResponse<any>> => {
    return deviceInfoAxios.get(`${DEVICE_INFO_API_URL}/journey-reports/historical/${tripId}`);
};

export const JourneyReportsService = {
    fetchHodReport,
    saveHodReport,
    fetchTmReport,
    saveTmReport,
    exportDocx,
    exportPdf,
    fetchHistorical,
    fetchHistoricalDetail,
};
